module.exports = __webpack_public_path__ + "static/logo-vasostrict-green-a3a71d58e8b85a67f7df183f12ac7b9d.png";